import { addDoc, collection } from "firebase/firestore";
import { db } from "../firebase";

export const enviarConfirmacion = async ({
  clientInfo,
  ticketId, 
  shopSettings,
  selectedLocation,
  selectedBarber,
  selectedDate,
  selectedTime,
  totalDuration,
  selectedServices, 
  totalPrice,      
  type = 'request' 
}) => {
  if (!clientInfo.email) return;

  try {
    // --- 1. CONFIGURACIÓN DINÁMICA SEGÚN TIPO ---
    const isConfirmed = type === 'confirmed';
    
    const emailSubject = isConfirmed 
        ? `✅ Reserva Confirmada #${ticketId.slice(-5)} - ${shopSettings.shopName}`
        : `📅 Solicitud de Reserva #${ticketId.slice(-5)} - ${shopSettings.shopName}`;

    const titleText = isConfirmed ? "¡Pago Recibido y Reserva Confirmada!" : "¡Solicitud de Reserva Recibida!";
    const bodyText = isConfirmed 
        ? "Tu pago ha sido procesado exitosamente. Tu turno está 100% asegurado."
        : "Hemos recibido tu solicitud. Te esperamos en el local para concretar el servicio.";
    
    const mainColor = isConfirmed ? "#22c55e" : "#f59e0b"; 

    // --- 2. PREPARACIÓN DE VARIABLES ---
    const ticketIdClean = ticketId.slice(-5);
    const clientFirstName = clientInfo.name.split(' ')[0] || 'Cliente';
    const shopName = shopSettings.shopName || 'Barbería';
    
    // Preparar lista de servicios (Texto)
    const servicesList = selectedServices && selectedServices.length > 0
        ? selectedServices.map(s => s.name).join(', ')
        : 'Servicio General';

    // Formatear Precio
    const formattedPrice = new Intl.NumberFormat('es-PY', { style: 'currency', currency: 'PYG' }).format(totalPrice || 0);

    const saasLogo = 'https://res.cloudinary.com/dz5ibyt7v/image/upload/v1793406258/barbergo-logo_tpj2tg.png';
    let shopLogo = shopSettings.logoUrl;
    if (!shopLogo || shopLogo.startsWith('blob:') || shopLogo.startsWith('file:') || shopLogo.startsWith('/')) {
        shopLogo = saasLogo; 
    }

    const mapLink = selectedLocation?.mapUrl || ''; 
    const reviewsLink = selectedLocation?.googleReviewsUrl || '';
    const locationName = selectedLocation?.name || shopName;
    const address = selectedLocation?.address || shopSettings?.address || 'Dirección no especificada';

    // --- 3. LÓGICA GOOGLE CALENDAR ---
    const formatForGCal = (dateObj) => {
        const pad = (n) => n < 10 ? '0'+n : n;
        return dateObj.getFullYear() +
               pad(dateObj.getMonth() + 1) +
               pad(dateObj.getDate()) + 'T' +
               pad(dateObj.getHours()) +
               pad(dateObj.getMinutes()) + '00';
    };

    const [year, month, day] = selectedDate.split('-').map(Number);
    const [hour, minute] = selectedTime.split(':').map(Number);
    const startDateObj = new Date(year, month - 1, day, hour, minute);
    const durationInMs = (totalDuration || 30) * 60000; 
    const endDateObj = new Date(startDateObj.getTime() + durationInMs);

    const startStr = formatForGCal(startDateObj);
    const endStr = formatForGCal(endDateObj);
    
    // Agregamos los servicios a los detalles del calendario también
    const gCalTitle = encodeURIComponent(`Reserva en ${shopName}`);
    const gCalDetails = encodeURIComponent(`Ticket #${ticketIdClean}\nServicios: ${servicesList}\nProfesional: ${selectedBarber.name}\nDirección: ${address}`);
    const gCalLocation = encodeURIComponent(address);
    const googleCalendarUrl = `https://www.google.com/calendar/render?action=TEMPLATE&text=${gCalTitle}&dates=${startStr}/${endStr}&details=${gCalDetails}&location=${gCalLocation}`;

    const c = {
        bg: "#0f172a", card: "#1e293b", text: "#f8fafc", muted: "#94a3b8",
        border: "#334155", darkInput: "#111827"
    };

    // --- 4. HTML ---
    const emailHtml = `
    <!DOCTYPE html>
    <html>
    <head>
    <meta charset="utf-8">
    <meta name="viewport" content="width=device-width, initial-scale=1.0">
    </head>
    <body style="margin: 0; padding: 0; background-color: ${c.bg}; font-family: 'Helvetica', 'Arial', sans-serif;">
        <table role="presentation" border="0" cellpadding="0" cellspacing="0" width="100%" style="background-color: ${c.bg}; padding: 40px 0;">
            <tr>
                <td align="center">
                    <table border="0" cellpadding="0" cellspacing="0" width="100%" style="max-width: 600px; background-color: ${c.card}; border-radius: 16px; overflow: hidden; box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.5); border: 1px solid ${c.border};">
                        <tr>
                            <td align="center" style="padding: 40px 20px 20px 20px;">
                                <img src="${shopLogo}" alt="${shopName}" style="width: 100px; height: 100px; object-fit: contain; display: block; margin: 0 auto; border-radius: 12px; background-color: ${c.bg}; padding: 5px; border: 1px solid ${c.border};">
                            </td>
                        </tr>
                        <tr>
                            <td align="center" style="padding: 0 20px;">
                                <h1 style="color: ${c.text}; font-size: 24px; margin: 0 0 10px 0;">¡Hola ${clientFirstName}!</h1>
                                <p style="color: ${c.muted}; font-size: 16px; margin: 0;">${titleText}</p>
                                <p style="color: ${c.muted}; font-size: 14px; margin-top: 5px;">${bodyText}</p>
                            </td>
                        </tr>
                        <tr>
                            <td style="padding: 30px;">
                                <div style="border: 2px dashed ${mainColor}; background-color: ${c.darkInput}; border-radius: 12px; padding: 20px; text-align: center;">
                                    <p style="color: ${c.muted}; font-size: 11px; text-transform: uppercase; letter-spacing: 2px; margin: 0 0 5px 0; font-weight: bold;">TICKET DE TURNO</p>
                                    <h2 style="color: ${mainColor}; font-size: 36px; margin: 0; letter-spacing: 2px; font-weight: 900;">#${ticketIdClean}</h2>
                                </div>
                            </td>
                        </tr>
                        <tr>
                            <td style="padding: 0 40px 10px 40px;">
                                <table width="100%" style="border-collapse: collapse;">
                                    <tr>
                                        <td style="padding: 15px 0; border-bottom: 1px solid ${c.border};"><span style="color: ${c.muted}; font-size: 14px;">📅 Fecha</span></td>
                                        <td style="padding: 15px 0; border-bottom: 1px solid ${c.border}; text-align: right;"><strong style="color: ${c.text}; font-size: 15px;">${selectedDate}</strong></td>
                                    </tr>
                                    <tr>
                                        <td style="padding: 15px 0; border-bottom: 1px solid ${c.border};"><span style="color: ${c.muted}; font-size: 14px;">⏰ Hora</span></td>
                                        <td style="padding: 15px 0; border-bottom: 1px solid ${c.border}; text-align: right;"><strong style="color: ${c.text}; font-size: 15px;">${selectedTime}</strong></td>
                                    </tr>
                                    <tr>
                                        <td style="padding: 15px 0; border-bottom: 1px solid ${c.border};"><span style="color: ${c.muted}; font-size: 14px;">✂️ Profesional</span></td>
                                        <td style="padding: 15px 0; border-bottom: 1px solid ${c.border}; text-align: right;"><strong style="color: ${mainColor}; font-size: 15px;">${selectedBarber.name}</strong></td>
                                    </tr>
                                    <tr>
                                        <td style="padding: 15px 0; border-bottom: 1px solid ${c.border}; vertical-align: top;"><span style="color: ${c.muted}; font-size: 14px;">💈 Servicios</span></td>
                                        <td style="padding: 15px 0; border-bottom: 1px solid ${c.border}; text-align: right;"><strong style="color: ${c.text}; font-size: 14px;">${servicesList}</strong></td>
                                    </tr>
                                    <tr>
                                        <td style="padding: 15px 0; border-bottom: 1px solid ${c.border};"><span style="color: ${c.muted}; font-size: 14px;">💰 Total</span></td>
                                        <td style="padding: 15px 0; border-bottom: 1px solid ${c.border}; text-align: right;"><strong style="color: ${mainColor}; font-size: 18px;">${formattedPrice}</strong></td>
                                    </tr>
                                    <tr>
                                        <td style="padding: 15px 0;"><span style="color: ${c.muted}; font-size: 14px;">📍 Lugar</span></td>
                                        <td style="padding: 15px 0; text-align: right;">
                                            <strong style="color: ${c.text}; font-size: 15px;">${locationName}</strong>
                                            <div style="color: ${c.muted}; font-size: 12px; margin-top: 4px;">${address}</div>
                                        </td>
                                    </tr>
                                </table>
                            </td>
                        </tr>
                        <tr>
                            <td align="center" style="padding: 0 40px 40px 40px;">
                                ${mapLink ? `
                                <a href="${mapLink}" target="_blank" style="display: block; background-color: ${mainColor}; color: #000000; text-decoration: none; padding: 14px 0; border-radius: 8px; font-weight: bold; font-size: 14px; text-align: center; margin-bottom: 12px; box-shadow: 0 4px 6px rgba(0,0,0,0.2);">
                                    📍 Ver Ubicación
                                </a>
                                ` : ''}
                                <a href="${googleCalendarUrl}" target="_blank" style="display: block; background-color: ${c.darkInput}; color: ${c.text}; border: 1px solid ${c.border}; text-decoration: none; padding: 14px 0; border-radius: 8px; font-weight: bold; font-size: 14px; text-align: center;">
                                    📅 Agendar en Google Calendar
                                </a>
                               ${reviewsLink ? `
                                <div style="margin-top: 20px; padding-top: 20px; border-top: 1px dashed #334155;">
                                    <a href="${reviewsLink}" target="_blank" style="display: block; background-color: #1e293b; color: #fbbf24; text-decoration: none; padding: 12px 0; border-radius: 8px; font-weight: bold; font-size: 13px; text-align: center; border: 1px solid #fbbf24;">
                                        ⭐⭐⭐⭐⭐ Califícanos en Google
                                    </a>
                                </div>
                                ` : ''}
                            </td>
                        </tr>
                        <tr>
                            <td align="center" style="background-color: ${c.darkInput}; padding: 20px; border-top: 1px solid ${c.border};">
                                <p style="color: ${c.muted}; font-size: 10px; text-transform: uppercase; letter-spacing: 1px; margin: 0 0 10px 0;">Plataforma gestionada por</p>
                                <a href="https://barbergo.com.py" target="_blank" style="text-decoration: none; display: inline-block;">
                                    <img src="${saasLogo}" alt="BarberGo" width="100" style="display: block; opacity: 0.8; filter: grayscale(100%) brightness(150%);" />
                                </a>
                            </td>
                        </tr>
                    </table>
                </td>
            </tr>
        </table>
    </body>
    </html>
    `;

    // --- 5. ENVÍO A FIREBASE ---
    await addDoc(collection(db, "mail"), {
        to: clientInfo.email,
        from: "BarberGo <reservas@barbergo.com.py>", 
        message: {
            subject: emailSubject,
            text: `${titleText} Ticket: ${ticketIdClean}. Servicios: ${servicesList}. Total: ${formattedPrice}`,
            html: emailHtml
        }
    });
    console.log("📨 Correo enviado:", type);

  } catch (error) {
    console.error("Error enviando email:", error);
  }
};